export const misc = {
    buttons: {
        login: 'Log in',
        logout: 'Log out'
    },
    fileInput: {
        dropFilesHere: 'Drop files here or',
        browseFiles: 'Browse files',
    },
    caseStatus: {
        received: 'Received',
        beingInvestigated: 'Follow-up',
        underCompletion: 'Case being completed',
        closed: 'Closed',
    },
    caseStatusDesc: {
        draft: 'Udkast',
        received: 'Bekræftelse modtaget',
        initialAssessment: 'Indledende vurdering',
        followUp: 'Opfølgning',
        underCompletion: 'Under afslutning',
        closed: 'Sagen er lukket',
    },
    fieldIsRequired: '* Field is required',

    errorPage: {
        404: {
            title: 'Upss, page not found',
            takeMe: 'Take me',
            home: 'home',
        },
        somethingWentWrong: {
            title: 'Upss, something went wrong',
            weAreWorkingOnIt: 'We are working on it',
            tryAgain: 'Try again ',
            later: 'later',
        },
    },
    language: 'Language'
};
